import React from 'react';
import { Number } from '../../common/common';

const TopHoldingsTable = (props) => {
  const { data, changeColor } = props;

  const icon = () => {
    return changeColor === 'c-positive' ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M4.08594 9.91732L9.91927 4.08398"
          stroke="#3BB87A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.08594 4.08398H9.91927V9.91732"
          stroke="#3BB87A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M4.08594 4.08268L9.91927 9.91602"
          stroke="#FF423D"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.08594 9.91602H9.91927V4.08268"
          stroke="#FF423D"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };

  return (
    <ul>
      {data.map((row, idx) => {
        return (
          <li key={row[7]}>
            <>
              <div className={`col_left ${!row[0] ? 'hidden' : ''}`}>
                <div className="index">{idx + 1}.</div>
                <div className="name__container">
                  <div className="name">{row[0]}</div>
                  <div className="symbol">{row[7]}</div>
                </div>
              </div>
              <div className={`col_right ${!row[0] ? 'hidden' : ''}`}>
                <div className="value">
                  {row[2] >= 0 ? '+' : ''}
                  <Number
                    value={row[2]}
                    usePrefix={false}
                    format={true}
                    isFormatWeb={true}
                  />
                </div>
                <div className={`change ${changeColor}`}>
                  {icon()}
                  {row[1] ? row[1].toFixed(2) : ''}%
                </div>
              </div>
            </>
          </li>
        );
      })}
    </ul>
  );
};

export default TopHoldingsTable;
